import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/wineTypes/form'
import { api, actionCreators } from 'store/modules/wineTypes'

const metadata = {
  icon: 'align-center',
  page: 'wineTypes',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
